import { render } from "./SlideOverMessages.vue?vue&type=template&id=16332588"
import script from "./SlideOverMessages.vue?vue&type=script&lang=js"
export * from "./SlideOverMessages.vue?vue&type=script&lang=js"
script.render = render

export default script